export enum OrderFormType {
  MANUAL = "MANUAL",
  STRATEGY = "STRATEGY"
}

export enum PriceType {
  LIMIT = "LIMIT",
  MARKET = 'MARKET',
  STOP_LOSS_MARKET = 'STOP LOSS MARKET',
  STOP_LOSS_LIMIT = 'STOP LOSS LIMIT'
}

export enum ORDERMODE {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum ORDERMODESWITCH {
  'BUY' = 0,
  'SELL' = 1
}

export enum ProductType {
  INTRADAY = 'INTRADAY',
  DELIVERY = 'DELIVERY'
}

export enum AlertsObjToOrderForm {
  disclosed_quantity = 'disclosedQuantity',
  order_mode = 'mode',
  order_validity = 'validity',
  price = 'price',
  product_type = 'product',
  quantity = 'quantity',
  lots = 'lots',
  trigger_price = 'triggerPrice',
  order_type = 'priceType'
}


export enum OrderFormToAlertsObj {
  disclosedQuantity = 'disclosed_quantity',
  mode = 'order_mode',
  validity = 'order_validity',
  price = 'price',
  product = 'product_type',
  quantity = 'quantity',
  lots = 'lots',
  triggerPrice = 'trigger_price',
  priceType = 'order_type'

}

export enum STATUS {
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING'
}
